import { useEffect } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { AnonymousPromoterState } from './AnonymousPromoterState';
import { HistoryViewModel } from '../../support/HistoryViewModel';

export const AnonymousPromoter: React.FC = () => {

    const promoter = useInstance(AnonymousPromoterState);
    useSubscription(() => promoter);

    const history = useInstance(HistoryViewModel);

    const path = history.getCurrentLocation().pathname;

    const isPathAllowingPromotion = !path.startsWith('/accept-invite') && !path.startsWith('/referral');

    useEffect(() => {
        if (isPathAllowingPromotion){
            promoter.handlePromotion();
        }
    }, [promoter, isPathAllowingPromotion]);

    return null;
};
